const defaultState = {
  entrada: {value: '0700'},
  pausa: {value: '1200'},
  retorno: {value: '1300'},
  saida: {value: '1700'}
}

const state = {...defaultState}

const getters = {
  entrada: state => state.entrada,
  pausa: state => state.pausa,
  retorno: state => state.retorno,
  saida: state => state.saida
}

const mutations = {
  entrada: (state, payload) => { state.entrada = payload },
  pausa: (state, payload) => { state.pausa = payload },
  retorno: (state, payload) => { state.retorno = payload },
  saida: (state, payload) => { state.saida = payload }
}

function mode (arr) {
  return arr.sort((a, b) =>
    arr.filter(v => v === a).length - arr.filter(v => v === b).length
  ).pop()
}

const actions = {
  entrada: ({ commit }, payload) => { commit('entrada', payload) },
  pausa: ({ commit }, payload) => { commit('pausa', payload) },
  retorno: ({ commit }, payload) => { commit('retorno', payload) },
  saida: ({ commit }, payload) => { commit('saida', payload) },
  calcInitialAutoComplete ({ commit }, payload) {
    let ordered = []
    payload.rows.forEach((r) => {
      let row = []
      r.groups.forEach(g => {
        row.push(g[0].machine_predicted.toString() + g[1].machine_predicted.toString())
        row.push(g[2].machine_predicted.toString() + g[3].machine_predicted.toString())
      })
      ordered.push(row)
    })
    let mostCommon = []
    for (let i = 0; i < 8; ++i) {
      const items = ordered.map(r => r[i]).filter(i => !isNaN(parseInt(i)))
      const common = mode(items)
      mostCommon.push(common)
    }
    const final = [
      mostCommon[0] + mostCommon[1],
      mostCommon[2] + mostCommon[3],
      mostCommon[4] + mostCommon[5],
      mostCommon[6] + mostCommon[7]
    ]
    commit('entrada', {value: final[0]})
    commit('pausa', {value: final[1]})
    commit('retorno', {value: final[2]})
    commit('saida', {value: final[3]})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/components/Sheet/AutoComplete/state.js